module.exports = __webpack_public_path__ + "img/wl_sl2.c6bbdbc8.jpg";